import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import NextLink from 'components/NextLink';
import Thumbnail from 'components/Thumbnail';

import styles from './styles.module.scss';
// @TODO: Replace icon on chevronRoundedRight when merge persons
const SpecialRubricCard = ({
	colorIndex,
	defaultImage,
	description,
	nextLink,
	title,
	url
}) => {
	// @TODO: add common helper getColor for this card and book card
	const getColor = (index) => {
		const colors = ['primary', 'secondary', 'tertiary', 'quaternary'];

		if (index >= colors.length) {
			return colors[index - colors.length];
		}

		return colors[index];
	};

	return (
		<NextLink className={styles.SpecialRubricCard} href={url} next={nextLink}>
			<div className={styles.SpecialRubricCard__GroupImages}>
				<Thumbnail
					className={styles.SpecialRubricCard__Img}
					file={defaultImage}
					params={{
						width: 530,
						height: 232
					}}
				/>
			</div>
			<div
				className={cx(
					styles.SpecialRubricCard__Body,
					styles[`SpecialRubricCard__Body_color_${getColor(colorIndex)}`]
				)}
			>
				<div className={styles.SpecialRubricCard__Title}>
					{title}
					&nbsp;
					<Icon
						icon="chevronRight"
						className={styles.SpecialRubricCard__Icon}
					/>
				</div>
				<div className={styles.SpecialRubricCard__Description}>
					{description}
				</div>
			</div>
		</NextLink>
	);
};

SpecialRubricCard.propTypes = {
	colorIndex: PropTypes.number,
	defaultImage: PropTypes.string.isRequired,
	description: PropTypes.string,
	nextLink: PropTypes.bool,
	title: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired
};

export default SpecialRubricCard;
